import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {DelayedRenderedMessageComponent} from 'botato-angular-lib';
import {QuizResponseItemData} from '../../type/QuizResponseItemData';
import {FreeTextQuizResponseItemDataText} from './FreeTextQuizResponseItemDataText';
import {FreeTextQuiz} from './FreeTextQuiz';
import {DeactivateMessageService} from '../../../deactivate-message.service';
import {Subscription} from 'rxjs';
import {FreeTextQuizUpdateAnswer} from './FreeTextQuizUpdateAnswer';
import {QuizQuestion} from '../../type/QuizQuestion';

@Component({
    selector: 'mm-free-text-quiz',
    templateUrl: './free-text-quiz.component.html',
    standalone: false
})
export class FreeTextQuizComponent extends DelayedRenderedMessageComponent implements OnInit, OnDestroy {

    public static TYPE = 'FreeText';
    public static UPDATE_TYPE = 'updateFreeText';

    public responseItemData!: QuizResponseItemData<FreeTextQuiz, FreeTextQuizResponseItemDataText, FreeTextQuizUpdateAnswer>;
    public question!: QuizQuestion;
    public quizNumber!: string;
    public isDeactivated: boolean | undefined;
    private subscription: Subscription | undefined;
    public updatedMessage = false;
    public sourceUrl: string | undefined;
    public sourceLabel: string | undefined;
    public questionTranslationId: string | undefined;
    public learningPackageTranslationId: string | undefined;
    public shouldShowMessage: boolean = false;

    constructor(private deactivateMessageService: DeactivateMessageService,
                private changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    public ngOnDestroy(): void {
        if (this.subscription !== undefined) {
            this.subscription.unsubscribe();
        }
    }

    public ngOnInit(): void {
        if (this.message.type === FreeTextQuizComponent.TYPE) {
            this.shouldShowMessage = true;

            this.updatedMessage = this.isMessageUpdated();
            if (this.updatedMessage) {
                this.createMessageUpdateData();
            } else {
                this.subscription = this.deactivateMessageService.deactivateOldCustomMessage(this.message);

                this.isDeactivated = this.message.data.deactivated !== undefined ? this.message.data.deactivated : false;

                this.createMessageData();
            }
        }

        if (this.message.type === FreeTextQuizComponent.UPDATE_TYPE) {
            this.subscription = this.deactivateMessageService.setUpdateOfLastMessage(this.message.data, this.changeDetectorRef);
        }
    }

    public isMessageUpdated(): boolean {

        const updateMessage = this.message.data.updateMessage;
        return updateMessage?.type === FreeTextQuizComponent.UPDATE_TYPE && updateMessage.responseItemData !== undefined;
    }

    public mediaLoaded(): void {
        this.componentRenderingCompleted();
    }

    private createMessageData(): void {

        this.responseItemData = this.message.data.responseItemData;
        this.quizNumber = this.responseItemData.learningSessionData.quizNumber;
        this.question = this.responseItemData.quiz.quiz;
    }

    private createMessageUpdateData(): void {

        this.responseItemData = this.message.data.updateMessage.responseItemData;
        const quizAnswerData = this.responseItemData.quizAnswerData!;
        this.question = quizAnswerData.quiz;
        this.quizNumber = quizAnswerData.quizNumber;
        this.sourceUrl = quizAnswerData.sourceUrl;
        this.sourceLabel = quizAnswerData.sourceLabel;
        this.questionTranslationId = quizAnswerData.id;
        this.learningPackageTranslationId = this.responseItemData.learningPackageTranslationId;
    }

    public override onAnyMessageSent(): void {
        if (this.isDeactivated !== true) {

            this.message.data.deactivated = true;
        }
    }
}
